var Backbone, SharedFooterUSPhoneNumberView, SharedPhoneNumberTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedPhoneNumberTemplate = require('../../../../phone_number.html.mustache');

SharedFooterUSPhoneNumberView = (function(superClass) {
  extend(SharedFooterUSPhoneNumberView, superClass);

  function SharedFooterUSPhoneNumberView() {
    return SharedFooterUSPhoneNumberView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterUSPhoneNumberView.prototype["class"] = 'support';

  SharedFooterUSPhoneNumberView.prototype.initialize = function(options) {
    if (options == null) {
      options = {};
    }
    this.I18nScope = 'modules.support';
    this.template = SharedPhoneNumberTemplate;
    return this.popupContainer = $("#popup");
  };

  SharedFooterUSPhoneNumberView.prototype.render = function() {
    GIG.Modal.open({
      el: this.popupContainer,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    return this.popupContainer.html(this.el);
  };

  SharedFooterUSPhoneNumberView.prototype.toHash = function() {
    var deal, hash, ref, ref1;
    deal = ((ref = Groupon.Support) != null ? (ref1 = ref.currentOrder) != null ? ref1.DEAL_TYPE : void 0 : void 0) || null;
    hash = {
      showMRDealPhoneNumbers: deal === "GETAWAYS_MARKET_RATE",
      isLivingSocial: window.brand === "livingsocial"
    };
    if (deal === "GETAWAYS_MARKET_RATE") {
      TrackingHub.add("SUPPORT-APP-MARKET-RATE-CALL-US", {
        data: window.currentUser
      });
    }
    return hash;
  };

  SharedFooterUSPhoneNumberView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SharedFooterUSPhoneNumberView.prototype.events = {
    'click .close-modal': "closeModal",
    'click .b-close': "closeModal"
  };

  return SharedFooterUSPhoneNumberView;

})(Backbone.View);

module.exports = SharedFooterUSPhoneNumberView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc2hhcmVkL2Zyb250ZW5kL3ZpZXdzL2Zvb3Rlci9VUy9waG9uZV9udW1iZXJfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9rdW1hcnJhL25hcGlzdHJhbm8vYnVpbGQvMTUwNDc3ODE0MzUyNi03NjE3Ny9wcm9kdWN0aW9uLTIwMTcuMDkuMDdfMDkuNTQvc3VwcG9ydF9hcHAvbW9kdWxlcy9zaGFyZWQvZnJvbnRlbmQvdmlld3MvZm9vdGVyL1VTL3Bob25lX251bWJlcl92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxJQUFBLGtFQUFBO0VBQUE7OztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUNiLHlCQUFBLEdBQTRCLE9BQUEsQ0FBUSx3Q0FBUjs7QUFFdEI7Ozs7Ozs7MkNBQ0osT0FBQSxHQUFPOzswQ0FFUCxVQUFBLEdBQVksU0FBQyxPQUFEOztNQUFDLFVBQVU7O0lBQ3JCLElBQUMsQ0FBQSxTQUFELEdBQWE7SUFDYixJQUFDLENBQUEsUUFBRCxHQUFZO1dBQ1osSUFBQyxDQUFBLGNBQUQsR0FBa0IsQ0FBQSxDQUFFLFFBQUY7RUFIUjs7MENBS1osTUFBQSxHQUFRLFNBQUE7SUFDTixHQUFHLENBQUMsS0FBSyxDQUFDLElBQVYsQ0FDRTtNQUFBLEVBQUEsRUFBSSxJQUFDLENBQUEsY0FBTDtNQUNBLGNBQUEsRUFBZ0IsSUFEaEI7TUFFQSxhQUFBLEVBQWUsSUFGZjtLQURGO0lBSUEsSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksTUFBQSxDQUFRLElBQUMsQ0FBQSxRQUFULEVBQW1CLElBQUMsQ0FBQSxNQUFELENBQUEsQ0FBbkIsRUFBOEIsSUFBQyxDQUFBLFNBQS9CLENBQVo7V0FDQSxJQUFDLENBQUEsY0FBYyxDQUFDLElBQWhCLENBQXFCLElBQUMsQ0FBQSxFQUF0QjtFQU5NOzswQ0FRUixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxJQUFBLDhFQUFvQyxDQUFFLDRCQUEvQixJQUE0QztJQUNuRCxJQUFBLEdBQ0U7TUFBQSxzQkFBQSxFQUF5QixJQUFBLEtBQVEsc0JBQWpDO01BQ0EsY0FBQSxFQUFnQixNQUFNLENBQUMsS0FBUCxLQUFnQixjQURoQzs7SUFFRixJQUFHLElBQUEsS0FBUSxzQkFBWDtNQUNFLFdBQVcsQ0FBQyxHQUFaLENBQWdCLGlDQUFoQixFQUFtRDtRQUFDLElBQUEsRUFBTSxNQUFNLENBQUMsV0FBZDtPQUFuRCxFQURGOztBQUVBLFdBQU87RUFQRDs7MENBU1IsVUFBQSxHQUFZLFNBQUE7SUFDVixHQUFHLENBQUMsS0FBSyxDQUFDLEtBQVYsQ0FBQTtBQUNBLFdBQU87RUFGRzs7MENBSVosTUFBQSxHQUNFO0lBQUEsb0JBQUEsRUFBdUIsWUFBdkI7SUFDQSxnQkFBQSxFQUFtQixZQURuQjs7Ozs7R0E5QndDLFFBQVEsQ0FBQzs7QUFpQ3JELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
